export default "__VITE_ASSET__Bq9I1q02__";